import { resetRemoteChangeSignal } from "@-/dev.improve.haniverse.lib.sync-push.signal";

// Browsers receive no sync pushes: an open tab hears about other devices through Pusher, and a
// tab that was closed checks the cloud when it opens.

export async function ensureSyncPushRegistration(_userId: string): Promise<void> {}

export async function unregisterSyncPush(): Promise<void> {
  resetRemoteChangeSignal();
}

export function watchSyncPushToken(_userId: string): () => void {
  return () => {};
}
